import { useContext } from 'react'

import type { ViewAsRoleValue } from 'features/auth/context/view-as-role-context-def'
import { ViewAsRoleContext } from 'features/auth/context/view-as-role-context-def'

export const useViewAsRoleContext = (): ViewAsRoleValue => {
  const value = useContext(ViewAsRoleContext)
  if (value === null) {
    throw new Error(
      'useViewAsRoleContext must be used inside <ViewAsRoleProvider>',
    )
  }
  return value
}
